import BaseStore from "@/stateManagement/BaseStore";
import type { VipTierEntity } from "@apps/rewards/modules/VipTiers/entities/RewardsVipTiersEntities";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface VipTiersState {
    tierList: VipTierEntity[];
}

const createInitialState = (): VipTiersState => ({
    tierList: [],
});

@singleton()
@StoreConfig({ name: "RewardsVipTiersStore" })
class RewardsVipTiersStore extends BaseStore<VipTiersState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsVipTiersStore;
